import { render, staticRenderFns } from "./Bertini.vue?vue&type=template&id=6830a4cc&scoped=true&"
import script from "./Bertini.vue?vue&type=script&lang=js&"
export * from "./Bertini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830a4cc",
  null
  
)

export default component.exports